export const API_URL = 'https://www.mlg-consulting.com/smart_territory/form/api.php';

//export const API_URL = 'https://www.myglobalvillage.com/api/'


export const DIR_ARCHIVES = '//www.mlg-consulting.com/manager_cc/docs/archives/';

export const DIR_DOCS_EVENT = "//www.mlg-consulting.com/manager_cc/events/img_uploaded/";

export const DIR_IMG_UPLOADED_CONTACTS = "//www.mlg-consulting.com/manager_cc/contacts/img_uploaded/";

export const CHECKIN_API_URL = 'https://www.mlg-consulting.com/smart_territory/form/checkin_api.php';

// formulaires activés sur un événement visibles par un contact (attributions faites dans le manager, #/event-create/)
export const FORMULAIRE_CONTACT_API_URL = 'https://www.mlg-consulting.com/smart_territory/form/formulaire_contact_api.php';
